import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Box, Typography } from '@mui/material';

export default function SeletorConfiguracaoStatus({ configuracao, setConfiguracao }) {

    const statusDisponiveis = [
        'Em Digitação',
        'Concluído',
        'Cancelado'
    ];

    const handleChange = (field, value) => {
        setConfiguracao(prev => ({
            ...prev,
            [field]: value
        }));
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                <FormControl sx={{ minWidth: 200 }}>
                    <InputLabel>Status Atual (opcional)</InputLabel>
                    <Select
                        value={configuracao.statusAtual || ''}
                        onChange={(e) => handleChange('statusAtual', e.target.value)}
                        label="Status Atual (opcional)"
                    >
                        <MenuItem value="">
                            <em>Qualquer status</em>
                        </MenuItem>
                        {statusDisponiveis.map((status) => (
                            <MenuItem key={status} value={status}>
                                {status}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl sx={{ minWidth: 200 }}>
                    <InputLabel>Novo Status</InputLabel>
                    <Select
                        value={configuracao.novoStatus || ''}
                        onChange={(e) => handleChange('novoStatus', e.target.value)}
                        label="Novo Status"
                        required
                    >
                        {statusDisponiveis.map((status) => (
                            <MenuItem key={status} value={status}>
                                {status}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>

            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                <strong>Resumo:</strong> Alterar status
                {configuracao.statusAtual ?
                    ` de "${configuracao.statusAtual}"` :
                    ' de qualquer status'
                }
                {configuracao.novoStatus ?
                    ` para "${configuracao.novoStatus}"` :
                    ' (configure o novo status)'
                }
            </Typography>
        </Box>
    );
}